define([], () => {
    return ['JsonRPCService', function (JsonRPCService) {
        return {
            getAccountContactSummary: function () {
                return JsonRPCService.send('pc', 'profileinfo/user', 'getAccountContactSummary', []);
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/services/UserAccountService.js
 **/